import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationEnergieApiService } from './organization-energie-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationEnergieApiService extends GeneratedOrganizationEnergieApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
